/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map, filter } from "lodash";
import { AcademicCycle } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { AttendanceItem } from "../AttendanceItem";

const academicCycleController = new AcademicCycle();

export function ListAttendance(props) {
  const { reload, status } = props;
  const [academicCycles, setAcademicCycles] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setAcademicCycles(null);
        const response = await academicCycleController.getAcademicCycles();
        setAcademicCycles(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!academicCycles) return <Loader active inline="centered" />;

  // Filtrar ciclos académicos por estado
  const filteredAcademicCycles = filter(academicCycles, (cycle) => {
    if (status === "active") {
      return cycle.status === 2 ; // Iniciado
    } else if (status === "inactive") {
      return cycle.status === 3 || cycle.status === 1; // Finalizado o Preinscripción
    }
    return true;
  });

  if (size(filteredAcademicCycles) === 0) {
    const message = status === "active" 
      ? "No existen ciclos académicos activos" 
      : "No existen ciclos académicos inactivos";
    return message;
  }

  return map(filteredAcademicCycles, (academicCycle) => (
    <AttendanceItem 
      key={academicCycle.id} 
      academicCycle={academicCycle} 
    />
  ));
}